import { Provider } from './Provider';
import { getUrlParameter } from '../../helpers/browser';
export class EgroupParameterProvider extends Provider {
    get source() {
        return getUrlParameter('egrps');
    }
    get medium() {
        return getUrlParameter('egrpm');
    }
    get campaign() {
        return getUrlParameter('egrpc');
    }
}
